import createReducer from 'shared/utils/createReducer';
import { ASK_PERMISSION } from 'modules/common/actions/askPermission';
import requestsStatuses from 'modules/common/constants/requestsStatuses';


const defaultState = { localMediaPermission: '' };

export default createReducer(defaultState, {
  [ASK_PERMISSION.success]: (state) => ({
    ...state,
    localMediaPermission: requestsStatuses.success,
  }),
  [ASK_PERMISSION.pending]: (state) => ({
    ...state,
    localMediaPermission: requestsStatuses.pending,
  }),
  [ASK_PERMISSION.failure]: (state) => ({
    ...state,
    localMediaPermission: requestsStatuses.failure,
  }),
});
